import { render, staticRenderFns } from "./dormImportDialog.vue?vue&type=template&id=2721bebf&"
import script from "./dormImportDialog.vue?vue&type=script&lang=js&"
export * from "./dormImportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports